import styled from "styled-components";

const Style = {
	TooltipContainer: styled.div`
		position: relative;
		display: flex;
		width: fit-content;
	`,
	//tooltip
	TooltipContent: styled.div`
		position: absolute;
		bottom: 125%;
		left: 50%;
		transform: translateX(-50%);
		background-color: #1F2024;
		color: #ffffff;
		padding: 12px 16px;
		border-radius: 8px;
		font-size: 12px;
		white-space: nowrap;
		z-index: 1000;
		opacity: ${props => props.$visible ? 1 : 0};
		visibility: ${props => props.$visible ? 'visible' : 'hidden'};
		transition: opacity 0.3s, visibility 0.3s;
		width: max-content;
		min-width: fit-content;

		&::after {
			content: '';
			position: absolute;
			top: 100%;
			left: 50%;
			transform: translateX(-50%);
			border: 5px solid transparent;
			border-top-color: #1F2024;
		}
	`,
	WarningIcon: styled.img`
		width: 20px;
		height: 20px;
		cursor: pointer;
	`,
	StatusWrapper: styled.div`
		display: flex;
  	align-items: center;
		gap: 4px;
		${({theme}) => theme.font.extra_small};
	`
}

export default Style
